export default "__VITE_ASSET__MtCr3cfq__"